module.exports = __webpack_public_path__ + "static/img/6.ee125d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/eng/6.png
// module id = lM8i
// module chunks = 0